module.exports = __webpack_public_path__ + "img/md-light-indigo.3c74e26b.svg";